import type { ForceOT } from "./types.ts";

export const MAX_DEFENSIVE_SLUGFEST_SCORE = 40;

/** Evaluate the winner and overtime requirements independently. */
export const matchesForcedResult = (
	forceWin: number | "tie" | undefined,
	forceOT: ForceOT,
	wonTid: number | undefined,
	overtimes: number,
	totalScore?: number,
) =>
	(forceOT === "defensiveRegulation" || forceOT === "defensiveOvertime"
		? totalScore !== undefined && totalScore <= MAX_DEFENSIVE_SLUGFEST_SCORE
		: true) &&
	(forceOT === false ||
		(forceOT === "defensiveRegulation"
			? overtimes === 0
			: forceOT === "defensiveOvertime"
				? overtimes > 0
				: typeof forceOT === "number"
					? overtimes === forceOT
					: overtimes > 0)) &&
	(forceWin === undefined ||
		(forceWin === "tie" ? wonTid === undefined : wonTid === forceWin));
